import { createTheme } from '@mui/material';

export const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#5865f2', // Discord blue
            light: '#7289da',
            dark: '#4752c4',
        },
        secondary: {
            main: '#57f287', // Discord green
            light: '#77dd77',
            dark: '#43a047',
        },
        background: {
            default: '#f8f9fa',
            paper: '#ffffff',
        },
        grey: {
            50: '#f8f9fa',
            100: '#e9ecef',
            200: '#dee2e6',
            300: '#ced4da',
            400: '#adb5bd',
            500: '#6c757d',
            600: '#495057',
            700: '#343a40',
            800: '#212529',
            900: '#0d1117',
        },
        text: {
            primary: '#2e3338',
            secondary: '#4e5058',
        },
        error: {
            main: '#ed4245',
        },
        warning: {
            main: '#faa61a',
        }
    },
    shape: {
        borderRadius: 12,
    },
    typography: {
        fontFamily: '"Inter", "Segoe UI", "Helvetica Neue", "Arial", sans-serif',
        h4: {
            fontWeight: 700,
            letterSpacing: '-0.02em',
        },
        h5: {
            fontWeight: 600,
            letterSpacing: '-0.01em',
        },
        body1: {
            fontSize: '0.95rem',
            lineHeight: 1.6,
        },
        body2: {
            fontSize: '0.875rem',
            lineHeight: 1.5,
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: 8,
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    }
                }
            }
        }
    }
});
